'use strict';

/**
 * BD.GoogleMap: Embeds google map into product pages.
 * 
 * ([JB, Mar 2019] Note this is currently disabled as we test OpenStreetMaps.  Feel free to
 * delete it if we end up not using it.) 
 */
var BD = window.BD = window.BD || {};

BD.GoogleMap = (function($) {
  var enabled = false;
  var gmApiKey = "";
  
  function onMapLoaded() {
    var mapCenter = [ 45.2487862,-76.3606792 ];
    var mapCenter = new google.maps.LatLng(mapCenter[0], mapCenter[1]);
    var bounds = new google.maps.LatLngBounds();

    var mapOptions = {
      mapTypeId: 'roadmap',
      zoom: 8,
      center: mapCenter
    };

    // Display a map on the page
    var map = new google.maps.Map(document.getElementById("map_canvas"), mapOptions);
    map.setTilt(45);
    var markers = BD.mapMarkers;

    if (markers) {
      markers.forEach(function(marker, idx) {
        var position = new google.maps.LatLng(marker[1], markers[2]);
        bounds.extend(position);        

        marker = new google.maps.Marker({
            position: position,
            map: map,
            title: marker[0],
            label: "LABEL" + idx,
            icon: 'https://cdn0.iconfinder.com/data/icons/alcohol-fill/512/white_beer-512.png'
        });
      });

      // Automatically center the map fitting all markers on the screen
      map.fitBounds(bounds);
      console.log("NEWBOUNDS ", bounds);
    };
  }
  
  function init() {
    var script = document.createElement('script');
    script.src = "//maps.googleapis.com/maps/api/js?key=" + gmApiKey + "&callback=BD.Map.onMapLoaded";
    document.body.appendChild(script);
  }

  if (enabled) {
    $(init);
  }
  
  return {
    onMapLoaded: onMapLoaded
  }
})(jQuery);
